<template>
	<div class="volunteer-home-intro-content">
		<div class="article__html" v-html="curData_.txt"></div>
	</div>
</template>

<script>
	import listMixin from '@/mixins/list.js'
	export default {
		mixins: [ listMixin ],
		data() {
			return {
				typeList: [{
					value: 'lxfs',
					label: '联系方式'
				}]
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.volunteer-home-intro-content{
		background-color: #fff;
	}
</style>
